(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/app.js');
'use strict';

const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  baseUrl
} = svs.core.data;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  routes
} = svs.myProfile.constants;
const CommunicationSettings = svs.myProfile.react.pages.communicationSettings.CommunicationSettings;
const {
  PlayerDetailsReduxProvider
} = svs.myProfile.react.store;
const {
  MyInformation
} = svs.myProfile.react.pages.myInformation;
const {
  Notifications
} = svs.myProfile.react.pages.notifications;
const {
  Kyc,
  KycQuestions
} = svs.myProfile.react.pages.kyc;
const {
  PdItemsMenu
} = svs.myProfile.react.shared.components;
const {
  GridBase
} = svs.tb_ui_react.gridbase;
const MyProfileApp = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  className: "bg-white",
  withRouter: true
}, React.createElement(ErrorBoundary, null, React.createElement(PlayerDetailsReduxProvider, null, React.createElement(PdItemsMenu, null), React.createElement(GridBase, {
  className: "f-left padding-1 main-content-constrained"
}, React.createElement(Route, {
  component: MyInformation,
  exact: true,
  path: routes.MY_PROFILE_HOME
}), React.createElement(Route, {
  component: MyInformation,
  exact: true,
  path: routes.MY_PROFILE_INFORMATION
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_TRANSCRIPT,
  render: () => React.createElement(MyInformation, {
    isTranscriptLink: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE,
  render: () => React.createElement(MyInformation, {
    isChangeMobile: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE,
  render: () => React.createElement(MyInformation, {
    isChangeMobile: true
  })
}), React.createElement(Route, {
  component: CommunicationSettings,
  exact: true,
  path: routes.MY_PROFILE_COMMUNICATION
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_COMMUNICATION_ADAPT_CONTENT,
  render: () => React.createElement(CommunicationSettings, {
    isAdaptContent: true
  })
}), React.createElement(Route, {
  component: Notifications,
  exact: true,
  path: routes.MY_PROFILE_NOTIFICATIONS
}), React.createElement(Route, {
  component: Kyc,
  exact: true,
  path: routes.MY_PROFILE_KYC
}), React.createElement(Route, {
  component: KycQuestions,
  exact: true,
  path: routes.MY_PROFILE_KYC_QUESTIONS
})))));
svs.myProfile.MyProfileApp = MyProfileApp;

 })(window);